"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DesignerLayoutRowModel = /** @class */ (function () {
    function DesignerLayoutRowModel(cards) {
        this.cards = cards || [];
    }
    DesignerLayoutRowModel.prototype.getFormCards = function () {
        return this.cards;
    };
    DesignerLayoutRowModel.prototype.getPageCards = function () {
        return this.cards;
    };
    DesignerLayoutRowModel.prototype.addCard = function (card) {
        this.cards.push(card);
    };
    DesignerLayoutRowModel.prototype.insertCardOnIndex = function (card, indexToPush) {
        this.cards.splice(indexToPush, 0, card);
    };
    return DesignerLayoutRowModel;
}());
exports.DesignerLayoutRowModel = DesignerLayoutRowModel;
//# sourceMappingURL=designer-layout-row.model.js.map